import {
    RequestConfigFunction,
} from 'app/types/request.types'
import loggerRequests from 'app/requests/Logger.requests'
import {
    BatchOperationPayload,
} from 'app/shared-components/BatchActions/hooks/useBatchUpload'
import {
    LoggerBatchUpdateFormValues,
    UpdateField,
} from './LoggerBatchUpdate.types'

export const updateFieldValues = {
    [UpdateField.RentingCompany]: 'Renting Company',
    [UpdateField.LoggerStatus]: 'Logger Status',
    [UpdateField.DestinationLocation]: 'Destination Location',
}

type Payload = BatchOperationPayload<LoggerBatchUpdateFormValues>

const mapParams = (data: Payload, fieldKey: keyof LoggerBatchUpdateFormValues) => {
    return {
        loggerId: data.id,
        data: {
            [fieldKey]: data.updateTo,
            batchOperationId: data.batchOperationId,
        },
    }
}

export const requestMap: Record<
    UpdateField,
    RequestConfigFunction<Payload>> = {
        [UpdateField.RentingCompany]: (
            data,
        ) => {
            return loggerRequests.batchUpdateRentingCompany(mapParams(data, 'rentingCompany'))
        },
        [UpdateField.LoggerStatus]: (
            data,
        ) => {
            return loggerRequests.batchUpdateLoggerStatus(mapParams(data, 'loggerStatus'))
        },
        [UpdateField.DestinationLocation]: (
            data,
        ) => {
            return loggerRequests.batchUpdateDestinationLocation(mapParams(data, 'destinationLocation'))
        },
    }
